import { render, staticRenderFns } from "./eventAb.vue?vue&type=template&id=22e74ce6&scoped=true"
import script from "./eventAb.vue?vue&type=script&lang=js"
export * from "./eventAb.vue?vue&type=script&lang=js"
import style0 from "./eventAb.vue?vue&type=style&index=0&id=22e74ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e74ce6",
  null
  
)

export default component.exports